import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import React, { useState, useEffect } from 'react';

const DynamicTable = React.memo(({ dataObject, showTotalRow = false, defaultSize = "medium", minWidth = 650 }) => {
  const [tableSize, setTableSize] = useState(defaultSize);

  useEffect(() => {
    if (dataObject && dataObject.size) {
      setTableSize('small');
    }
  }, [dataObject]);


  if (!dataObject || !dataObject.data || !Array.isArray(dataObject.data) || dataObject.data.length === 0) {
    return <p>Currently, no information is available. <b/> Please choose a different value.</p>
  }

  const fieldNames = dataObject.data.length > 0 ? Object.keys(dataObject.data[0]) : [];
  const lastIndex = dataObject.data.length - 1;

  function formatFieldName(fieldName) {
    return fieldName
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

  return (
      <TableContainer component={Paper} sx={{height: '100%'}}>
        <Table stickyHeader sx={{minWidth: minWidth, backgroundColor: '#2C3E50' }} size={tableSize} aria-label="simple table">
          <TableHead>
            <TableRow>
                {fieldNames.map((fieldName) => (
                  <TableCell align="center" key={fieldName}   sx={{ backgroundColor: '#0a1d33', color: 'white'}}>
                    <strong>{formatFieldName(fieldName)}</strong>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
        <TableBody>
          {dataObject.data.map((row, index) => {
            const lastIndex = dataObject.data.length - 1;
            const isTotal = index === lastIndex && String(row[fieldNames[0]]).toLowerCase().includes('total');

            return (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: isTotal ? '#3B4E65' : index % 2 === 0
                    ? '#f4f7fb' : '#ffffff',
                }}
              >
                {fieldNames.map((fieldName) => (
                  <TableCell
                    align="center"
                    key={fieldName}
                    sx={{
                      fontWeight: isTotal ? 'bold' : 'normal',
                      color: isTotal ? 'white' : 'inherit',
                    }}
                  >
                    {row[fieldName]}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
        </Table>
      </TableContainer>
  )
});

export default DynamicTable